import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconsInitConfigType, IconUIComponent } from '@shared-ui-kit';

@Component({
  selector: 'fr8bot-web-card-v-1',
  templateUrl: './web-card-v-1.html',
  styleUrl: './web-card-v-1.scss',
  imports: [IconUIComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebCardV1 {
  icon = input<IconsInitConfigType | null>(null);
  title = input('');
  description = input('');
}
